import { MediaGuideMetadata } from '@/utils/media/types';
import { EventProperties } from '@calm/evexia-analytics';
import { ProgramQueueSource, QueueSource, QueueSourceKind } from '../types';

export const PROGRAM_QUEUE_SOURCE: ProgramQueueSource = {
    kind: QueueSourceKind.Program,
};

/** Loop resets when this changes between opens; a program source keys on its programId. */
export function queueSourceKey(
    source: QueueSource,
    guide: Pick<MediaGuideMetadata, 'programId'>
): string {
    return source.kind === QueueSourceKind.Playlist
        ? `${QueueSourceKind.Playlist}:${source.playlistId}`
        : `${QueueSourceKind.Program}:${guide.programId}`;
}

/** Props every session event of a track from this source carries: PlaylistId/PlaylistName. */
export function queueSourceTrackProps(
    source: QueueSource | undefined
): EventProperties {
    if (source?.kind !== QueueSourceKind.Playlist) return {};
    return {
        PlaylistId: String(source.playlistId),
        PlaylistName: source.playlistName,
    };
}
